export const CLIENT_ID = 'bolt';
export const CLIENT_ORIGIN = import.meta.env.VITE_CLIENT_ORIGIN ?? 'https://jake.stackblitz.com';
export const WEBCONTAINER_ORIGIN = import.meta.env.VITE_WEBCONTAINER_ORIGIN ?? CLIENT_ORIGIN;
export const SOCIAL_PREVIEW_ORIGIN = import.meta.env.SOCIAL_PREVIEW_ORIGIN ?? 'https://social-img.staticblitz.com';
export const FRAMER_ORIGIN = import.meta.env.BLOG_ORIGIN ?? 'https://bolt-blog.framer.website';
export const PUBLIC_PAGES_ORIGIN = 'https://bolt-public-pages.pages.dev';
export const APPSIGNAL_KEY = import.meta.env.VITE_APPSIGNAL_API_KEY;
export const BOLT_FOLDER = '.bolt';
export const SUPABASE_MIGRATIONS_FOLDER = 'supabase/migrations';
export const SUPABASE_EDGE_FUNCTIONS_FOLDER = 'supabase/functions';
export const SUPABASE_EDGE_FUNCTIONS_SHARED_FOLDER = '_shared';
export const SUPABASE_DISCARDED_MIGRATIONS_FOLDER = `${BOLT_FOLDER}/supabase_discarded_migrations`;
export const BOLT_SUPABASE_CONNECT_MSG_PREFIX = 'bolt-supabase-connect';
export const BOLT_PROMPT_PATH = '.bolt/prompt';
export const BOLT_DEPLOY_MSG_MAX_LENGTH = 40;
export const DEV_SESSION_SECRET = import.meta.env.DEV ? 'LZQMrERo3Ewn/AbpSYJ9aw==' : undefined;
export const DEV_PAYLOAD_SECRET = import.meta.env.DEV ? '2zAyrhjcdFeXk0YEDzilMXbdrGAiR+8ACIUgFNfjLaI=' : undefined;
export const REFERRAL_ID_PARAM = 'rid';
export const IGNORE_BLOB_ID = '__ignore__';
export const GITHUB_SYNC_PREFIX = 'github-sync-';
export const BOLT_ATTACHMENTS_PREFIX = 'bolt-attachments-';
export const DEFAULT_GITHUB_BRANCH = 'main';
export const GITHUB_BRANCH_PARAM = 'github-branch';
export const BOLT_HOSTING_DNS = 'site-dns.bolt.host';

export const COPIED_MESSAGE_TIMEOUT = 2500;

// common timeout for when we need to reload the page after some interaction/request
export const WINDOW_RELOAD_TIMEOUT = 1500;

// specific message ids

// first fake assistant message shown after importing a project
export const BOLT_IMPORT_ID = 'bolt-import';

// fake assistant message shown when loading an existing project with a chat history
export const BOLT_BOOTSTRAP_ID = 'bolt-bootstrap';

// swap to true to bring referrals back
export const REFERRALS_FEATURE_ENABLED = true;

export const MSG_DEPLOY = 'Publish this application.';
export const MSG_DOMAIN_SETUP = 'Set up a domain for this application.';
export const MSG_INTEGRATE_STRIPE = 'Integrate stripe into my app';

export const MSG_RESTORE_PREFIX = 'Restore version:';
export const MSG_RESTORE_RESPONSE_PREFIX = "I've restored your project to the version:";

/**
 * Those names are the names of the Supabase edge functions
 * for stripe. If we want to update them in the future we could:
 *
 *   1. Add a version as a suffix (like v2)
 *   2. Compute a content hash of the version and if the hash
 *      changed, update them
 *
 * The problem with 2. is that then the AI should never change
 * those files (which some users might want to do).
 */
export const STRIPE_WEBHOOK_SLUG = 'stripe-webhook';
export const STRIPE_CHECKOUT_SLUG = 'stripe-checkout';

export const SPECIAL_TOKENS_NAME = '🎨';

/**
 * Threshold for considering a request as "large" based on the number of input tokens.
 */
export const LARGE_REQUEST_TOKEN_COUNT = 100_000;

/**
 * This is legacy and is no longer used but we keep it for backwards compatibility.
 *
 * @deprecated
 */
export const BOLT_MODIFICATIONS = `${BOLT_FOLDER}/modified.json`;

export const DEFAULT_PROJECT_INFO = {
  title: 'Bolt.new project',
  description: 'Prompt, run, edit & publish apps',
};

export const INDEX_PAGE_TITLE = 'Bolt AI builder: Websites, apps & prototypes';
export const INDEX_PAGE_DESCRIPTION =
  'Build and scale high-performing websites & apps using your words. Join millions and start building today.';
export const PRICING_PAGE_TITLE = 'Plans & pricing: Bolt’s AI powered website and app builder';
export const PRICING_PAGE_DESCRIPTION =
  'Start for free. Unlock advanced features as you grow. Build websites, apps, and prototypes faster with Bolt.';
export const FIGMA_IMPORT_PAGE_TITLE = 'Bolt.new Figma project';
export const GITHUB_IMPORT_PAGE_TITLE = 'Bolt.new GitHub project';
export const BUILD_WITH_BOLT_PAGE_TITLE = 'Build with Bolt';
export const BUILD_WITH_BOLT_PAGE_DESCRIPTION =
  'Hosting an internal hackathon, demo day, workshop, or build-a-thon? Apply to the Build with Bolt Events Program for partnership support.';
export const BUILD_WITH_BOLT_CTA_LINK = 'https://bolt.fyi/build-with-bolt';

export const SHOW_MADE_IN_BOLT_BADGE = true;

export interface ProjectInfo {
  id: string;
  slug: string;
  title: string;
  description: string;
}
